<template>
  <div>
    <div class="payment__title">{{ $t('book.trip_information') }}</div>
    <div class="payment__content">
      <div v-if="mode === 'success'" class="payment__content__item">
        <label>{{ $t('book.order_code') }}</label>
        <div>{{ ticketCode }}</div>
      </div>
      <div class="payment__content__item">
        <label>{{ $t('common.customer_name') }}</label>
        <div>{{ get(bookingInfo, 'customer_name', '') }}</div>
      </div>
      <div class="payment__content__item">
        <label>{{ $t('common.phone') }}</label>
        <div>{{ get(bookingInfo, 'customer_phone', '') }}</div>
      </div>
      <div class="payment__content__item">
        <label>Email</label>
        <div>{{ get(bookingInfo, 'customer_email', '') }}</div>
      </div>
      <hr>
      <div class="payment__content__item mt-0">
        <label>{{ $t('book.vehicle_name') }}</label>
        <div>{{ get(bookingInfo, 'company_name', '') }}</div>
      </div>
      <div class="payment__content__item">
        <label>{{ $t('book.vehicle_type') }}</label>
        <div>{{ get(bookingInfo, 'vehicle_type', '') }}</div>
      </div>
      <div
          v-if="mode === 'success'"
          class="payment__content__item"
      >
        <label>{{ $t('book.seat') }}</label>
        <div>
          {{ get(bookingInfo, 'seat_name', '') }}
        </div>
      </div>
    </div>
    <div class="payment__title">{{ $t('book.transaction_information') }}</div>
    <div class="payment__content">
      <template v-if="mode === 'success'">
<!--        <div class="payment__content__item">
          <label>{{ $t('book.payment_methods') }}</label>
          <div>
            {{ paymentTypeName }}
          </div>
        </div>-->
        <div class="payment__content__item">
          <label>{{ $t('book.status') }}</label>
          <div>
            {{ $t('book.successful_booking') }}
          </div>
        </div>
        <hr>
      </template>
      <div class="flex-justify-between">
        <span>{{ $t('book.fare') }}</span>
        <div>
          <div
              v-for="(item, key) in fareList"
              :key="key"
              class="t-right mb-4"
          >
            <span>{{ item.length }} x </span><strong>{{ formatMoney(key) }}{{ currency }}</strong>
            <div v-if="!get(bookingInfo, 'unchoosable', true)" class="text-12-400">{{ $t('book.seat') }} {{ item.toString() }}</div>
          </div>
        </div>
      </div>
      <hr v-if="surchargeTotal != 0 || serviceFeeFare != 0">
      <div v-if="surchargeTotal != 0" class="flex-justify-between">
        <span>{{ $t('common.surcharge') }}</span>
        <div>
          <div class="t-right mb-4">
            <strong>{{ formatMoney(surchargeTotal) }}{{ currency }}</strong>
          </div>
        </div>
      </div>
      <div v-if="serviceFeeFare != 0" class="flex-justify-between">
        <span>{{ $t('common.service_fee_name') }}</span>
        <div>
          <div class="t-right mb-4">
            <strong>{{ formatMoney(serviceFeeFare) }}{{ currency }}</strong>
          </div>
        </div>
      </div>
      <hr>
      <div class="flex-justify-between">
        <strong>{{ $t('book.total') }}</strong>
        <strong class="payment__total-price">{{ finalTotal }}</strong>
      </div>
    </div>
  </div>
</template>

<script>
import {formatMoney, formatTime} from "../../utils/helpers";
import {get, isEmpty} from "lodash";

export default {
  props: {
    bookingInfo: {
      type: Object,
      default: () => {},
    },
    bookingSuccessInfo: {
      type: Object,
      default: () => {},
    },
    paymentType: {
      type: Number,
      default: 1,
    },
    mode: {
      type: String,
      default: 'payment',
    }
  },
  computed: {
    finalTotal() {
      return formatMoney(this.totalFare + this.serviceFeeFare) + this.currency
    },
    fareList() {
      const results = {};
      (this.bookingInfo?.seat_chooses || []).forEach(item => {
        if (isEmpty(results[item.fare])) {
          results[item.fare] = [item.seat_code]
        } else {
          results[item.fare].push(item.seat_code)
        }

      })

      return results
    },
    currency() {
      return this.$i18n.locale === "vn" ? "đ" : "VND";
    },
    paymentTypeName() {
      return this.paymentType === 1 ? this.$t('book.payment_bank_card') : this.$t('book.direct_payment');
    },
    bookingCode() {
      return get(this.bookingSuccessInfo, "booking_code", '')
    },
    ticketCode() {
      return get(this.bookingSuccessInfo, "code", '')
    },
    totalFare () {
      return parseInt(this.bookingInfo?.total_fare || 0)
    },
    serviceFee() {
      return parseInt(serviceFee || 0)
    },
    serviceFeeFare() {
      if (this.totalFare === 0 || this.serviceFee === 0) {
        return 0
      }

      return this.totalFare * this.serviceFee / 100
    },
    surchargeTotal () {
      return this.bookingInfo?.seat_chooses.length *
          (parseInt(this.bookingInfo.surcharge_pickup) + parseInt(this.bookingInfo.surcharge_drop_off))
    }
  },
  methods: {
    get,
    formatMoney,
    formatTime,
  }
}
</script>
